import Vue from 'vue'
import Vuex from 'vuex'
import { storeBase } from '../store/baseStore'

// override default store modifying storeBase for servicios_digitales

Vue.use(Vuex)
export default new Vuex.Store(storeBase)



// WEBPACK FOOTER //
// ./src/servicios_digitales_costa/store.js